export default "__VITE_ASSET__BEDh4nw7__"